export function createWrapperDiv({id}: {id: string}) {
  const container = document.createElement('div');
  container.id = id;
  container.className = 'fixed top-0 left-0 w-full h-full pointer-events-none';
  container.style.cssText =
    'height: fill-available; height: -webkit-fill-available';
  document.body.appendChild(container);
  return container;
}
